import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useEffect } from 'react';
import { setAccessToken, setRefreshToken, setTokenExpiryTime } from 'utils/AuthUtils/tokenUtils';
import { useStore } from 'hooks/useStore';

const useLoginCallback = () => {
  const {
    UserStore: { setIsAuthenticated, fetchUserDetails },
  } = useStore();
  const [access] = useSearchParamsState('access', '');
  const [refresh] = useSearchParamsState('refresh', '');

  useEffect(() => {
    if (access && refresh) {
      setAccessToken(access);
      setRefreshToken(refresh);
      setIsAuthenticated(true);
      fetchUserDetails();

      const utcDateObject = new Date();
      utcDateObject.setHours(utcDateObject.getHours() + 24);
      setTokenExpiryTime(utcDateObject.toUTCString());
      window.location.href = '/';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run when access/refresh from URL are set
  }, []);

  return {};
};

export default useLoginCallback;
